const master = {
    hasil_pengecekan_lapangan: {
        "1": "Ada, alamat KTP/KK di SLS terkait",
        "2": "Ada, alamat KTP/KK tidak di SLS terkait",
        "3": "Tidak ditemukan"
    },
    jenis_kelamin: {
        "L": "Laki-laki",
        "P": "Perempuan"
    },
    status_hubungan_keluarga: {
        "1": "KEPALA KELUARGA",
        "2": "SUAMI",
        "3": "ISTRI",
        "4": "ANAK",
        "5": "ORANG TUA",
        "6": "MERTUA",
        "7": "MENANTU",
        "8": "CUCU",
        "9": "PEMBANTU",
        "10": "FAMILI LAIN",
        "11": "LAINNYA"
    },
    kewarganegaraan: {
        "0": "WNI",
        "1": "WNA"
    },
    status_nik: {
        "1": "NIK NULL/kosong",
        "2": "NIK selain angka, tidak 16 digit, atau mengikuti pola tertentu",
        "3": "NIK ketemu di dukcapil, namun ada perbedaan nama",
        "4": "NIK 16 digit, tapi tidak ketemu di dukcapil",
        "99": "Valid"
    },
    status_nomor_kk: {
        "1": "KK NULL/kosong",
        "2": "KK selain angka, tidak 16 digit, atau mengikuti pola tertentu",
        "99": "Valid"
    },
    sumber_data: {
        "1": "Data tunggal",
        "2": "Ganda tak terselesaikan tetapi sudah ditunggalkan",
        "31": "status NIK bukan 99 tetapi masuk data SP",
        "32": "hasil pengecekan lapangannya tidak ditemukan tetapi masuk data SP",
        "33": "dp desa tidak terinput tetapi masuk data SP",
        "41": "bridging dari mas wahyu PHD",
        "42": "bridging dari SM WNA",
        "null": "Data dari kondisi 16 Desember (untuk mengambil record yang NIK nya tidak valid)"
    },
    agama: {
        "1": "ISLAM",
        "2": "KRISTEN",
        "3": "KATHOLIK",
        "4": "HINDU",
        "5": "BUDHA",
        "6": "KONGHUCHU",
        "7": "ALIRAN KEPERCAYAAN"
    },
    pendidikan: {
        "1": "TIDAK/BELUM SEKOLAH",
        "2": "BELUM TAMAT SD/SEDERAJAT",
        "3": "TAMAT SD/SEDERAJAT",
        "4": "SLTP/SEDERAJAT",
        "5": "SLTA/SEDERAJAT",
        "6": "DIPLOMA I/II",
        "7": "AKADEMI/DIPLOMA III/S. MUDA",
        "8": "DIPLOMA IV/STRATA I",
        "9": "STRATA II",
        "10": "STRATA III"
    },
    status_pernikahan: {
        "1": "BELUM KAWIN",
        "2": "KAWIN",
        "3": "CERAI HIDUP",
        "4": "CERAI MATI",
    },
    status_keberadaan: {
        "1": "Ditemukan",
        "2": "Tidak Ditemukan",
        "3": "Pindah",
        "4": "Meninggal",
    }
};
export default master;